import { getAccessToken } from "@devforce/trailhead-client-auth";

export async function withImageProxy(imgURL: string): Promise<string> {
  const accessToken = await getAccessToken();
  return accessToken ? `/mytrailhead-id/profile_picture` : imgURL;
}
